import styled from '@emotion/styled';
import { Icon, tokens } from '@hotjar/hotsauce';
import { useTranslation } from 'react-i18next';

const ErrorContainer = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100%;
`;

const ErrorTitle = styled.div`
  ${tokens.text('header3')}
  margin: ${tokens.spacer.x3} 0 ${tokens.spacer.x2};
`;

const ErrorSubtitle = styled.div`
  ${tokens.text('header5')}
`;

export const HighlightError = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <ErrorContainer>
      <Icon size="xl" icon="error" />
      <ErrorTitle>{t('highlights:single.downloading-error.title')}</ErrorTitle>
      <ErrorSubtitle>{t('highlights:single.downloading-error.copy')}</ErrorSubtitle>
    </ErrorContainer>
  );
};
